import React from "react";

const Page2: React.FC = () => {
  return <h1>Welcome to Page 2</h1>;
};

export default Page2;
